/* eslint-disable camelcase */
/**
 * @author Fernando Ruano
 * @file index.js
 * @description Profile Services
 */

// Core
import endpoints from '@nephro/config/endpoints';
import { externalConnector } from '@nephro/core/connector';

// Endpoints
const { profile: profileEndpoints } = endpoints;

export class ProfileService {
  constructor(http) {
    this.http = http;
  }

  /**
   * Get profiles list with pagination
   * @param { string } paged - Activate pagination.
   * @param { string } limit - Items per page.
   * @param { string } page - Current page.
   * @return { Object } - Get profiles list.
   */
  getProfiles = async (paged, limit, page) => {
    const queryParam = `?limit=${limit}&page=${page}&paged=${paged}`;
    let url = profileEndpoints.base;
    if (paged) {
      url = `${url}${queryParam}`;
    }
    return this.http.get(url);
  };

  /**
   * Get profile info by id
   * @param { string } id - Profile id.
   * @return { Object } - Get profiles list.
   */
  getProfileById = async (id) => {
    const url = `${profileEndpoints.base}/${id}`;
    return this.http.get(url);
  };

  /**
   * Create profile
   * @param { string } name - Profile name.
   * @param { string } description - Profile description.
   * @return { promise } - The profile promise object.
   */
  createProfile = async (name, description) => {
    const body = { name, description };
    const url = profileEndpoints.base;
    return this.http.post(url, body);
  };

  /**
   * Delete profile by id
   * @param { string } id - Profile id.
   * @return { Object } - Get profiles list.
   */
  deleteProfileById = async (id) => {
    const url = `${profileEndpoints.base}/${id}`;
    return this.http.delete(url);
  };

  /**
   * Update profile
   * @param { string } name - Profile name.
   * @param { string } description - Profile description.
   * @param { string } id - Profile id.
   * @return { promise } - The profile promise object.
   */
  updateProfile = async (name, description, id) => {
    const body = { name, description };
    const url = `${profileEndpoints.base}/${id}`;
    return this.http.update(url, body, {}, 'put');
  };
}

export default new ProfileService(externalConnector);
